<template>
  <div class="affirm-messaging">
    <div class="affirm-messaging__shop-pay">
      <icon-shop-pay-affirm />

      <a
        href="https://shoppay.affirm.com/help/s/article/about-sp"
        rel="noopener noreferrer"
        target="_blank"
      >
        <span
          class="visually-hidden"
          v-text="$string('product.payment_options.shop_pay_learn_more')"
        />
        <icon-info />
      </a>
    </div>

    <p
      :id="`affirm-messaging-${namespace}`"
      class="affirm-as-low-as text-body-s-regular"
      :data-page-type="pageType"
      :data-affirm-color="logoColor"
      :data-amount="price"
    />
  </div>
</template>

<script>

/**
 * Vue: Affirm messaging (affirm-messaging)
 * -----------------------------------------------------------------------------
 * Affirm on-site messaging component.
 * - https://docs.affirm.com/payments/docs/html-reference
 *
 * @param {String} [logoColor] - Control Affirm logo colour.
 * @param {String} namespace - Placement namespace.
 * @param {String} [pageType] - Location of affirm messaging component.
 * @param {Number} price - Product, variant or cart price.
 * @param {Object|Boolean} variant - Canvas formatted variant object.
 *
 */
import IconInfo from '~icons/general/info.svg'
import IconShopPayAffirm from '~icons/general/shop-pay-affirm.svg'

export default {
  name: 'AffirmMessaging',

  components: {
    IconInfo,
    IconShopPayAffirm,
  },

  props: {
    logoColor: {
      type: String,
      default: 'black',
      validator: (value) => {
        return ['black', 'white'].includes(value)
      },
    },
    namespace: {
      type: String,
      default: '',
      required: true,
    },
    pageType: {
      type: String,
      default: 'homepage',
      validator: (value) => {
        return [
          'homepage',
          'landing',
          'search',
          'category',
          'product',
          'cart',
          'payment',
          'banner',
        ].includes(value)
      },
    },
    price: {
      type: Number,
      default: 0,
      required: true,
    },
    variant: {
      type: [Boolean, Object],
      default: false,
    },
  },

  watch: {

    /**
     * Watch price update to refresh placement.
     * @param {Number} newPrice - New price.
     * @param {Number} oldPrice - Old price.
     */
    price(newPrice, oldPrice) {
      if (newPrice === oldPrice) {
        return
      }

      this.refreshPlacement()
    },

    /**
     * Watch variant update to refresh placement.
     */
    variant() {
      this.refreshPlacement()
    },
  },

  mounted() {
    this.refreshPlacement()
  },

  methods: {

    /**
     * Refresh placement.
     */
    async refreshPlacement() {
      if (!window.affirm) {
        return
      }

      await this.$nextTick()
      window.affirm.ui.refresh()
    },
  },
}
</script>

<style lang="scss">
@import './affirm-messaging';
</style>
